import { IconProp } from '@fortawesome/fontawesome-svg-core';
import { faPen } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { SiteView } from '~/components/site/SiteView';
import { Attributes } from '~/components/ui/Attributes';
import { InfoCard } from '~/components/ui/InfoCard/InfoCard';
import { Loading } from '~/components/ui/Loading';
import { ReadValue } from '~/components/ui/ReadValue';
import { ViewSpaceQuery, useViewSpaceQuery } from '~/generated/graphql';
import { SideLayout } from '~/layouts/side/SideLayout';

type Space = ViewSpaceQuery['spaces'][number];

export const SpaceView = () => {
  const navigate = useNavigate();
  const { spaceId, siteId } = useParams();
  const { t } = useTranslation();
  const [showSite, setShowSite] = useState(false);

  const handleLocationClick = () => setShowSite(true);
  const handleCloseModal = () => setShowSite(false);

  const [result] = useViewSpaceQuery({
    pause: !spaceId,
    variables: { id: spaceId! },
    requestPolicy: 'cache-and-network',
  });
  const space = result.data?.spaces[0];
  if (!space) {
    return <Loading />;
  }

  const spaceFields = [
    ...(space.location
      ? [
          {
            label: 'Space Location',
            value: (
              <>
                {space.location.name}{' '}
                <span className='text-tertiary'>
                  ({space.location.__typename})
                </span>
              </>
            ),
            onClick: handleLocationClick,
          },
        ]
      : []),

    // Status is handled automatically by InfoCard component
    // Additional fields can be added here if needed
  ];

  return (
    <SideLayout>
      <div className='mb-1'>
        <SideLayout.Head
          rightSlot={
            <Link
              className='ml-1 mt-1.5 flex h-9 w-9 cursor-pointer items-center justify-center rounded-full hover:bg-grey-10'
              to='edit'
            >
              <FontAwesomeIcon
                icon={faPen as IconProp}
                className='h-4 text-secondary'
              />
            </Link>
          }
          onClose={() =>
            siteId ? navigate(`/sites/${siteId}`) : navigate('/spaces')
          }
        ></SideLayout.Head>
      </div>

      <SideLayout.Body>
        {/* <div className='mb-5'>
          <StatusBadge value={space.status} rounded />
        </div> */}
        <InfoCard
          title={space.name}
          image={space.image || undefined}
          status={space.status}
          fields={spaceFields}
          modal={
            space.location
              ? {
                  isOpen: showSite,
                  onClose: handleCloseModal,
                  title: space.location.name,
                  content: (
                    <SiteView
                      isPopup={true}
                      siteId={space.location.id}
                      onClose={handleCloseModal}
                    />
                  ),
                }
              : undefined
          }
        />

        <ReadValue label='description' value={space.description} />
        <ReadValue label='notes' value={space.notes} />

        {/* @ts-expect-error FIXME */}
        <Attributes data={space} />
      </SideLayout.Body>
    </SideLayout>
  );
};
